webpackJsonp([94533468323174],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IssueNavigation = function (_React$Component) {
	  _inherits(IssueNavigation, _React$Component);
	
	  function IssueNavigation(props) {
	    _classCallCheck(this, IssueNavigation);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  IssueNavigation.prototype.render = function render() {
	    var _this2 = this;
	
	    var issue_navigation = [{ name: 'moving_image',
	      title: 'moving image' }, { name: 'still_image',
	      title: 'still image' }, { name: 'textz',
	      title: 'textz' }, { name: 'soundz',
	      title: 'soundz' }].map(function (section_metadata, index) {
	      return _this2.props.issue_data[section_metadata.name + '_count'] > 0 ? _react2.default.createElement(
	        'li',
	        { key: index },
	        _react2.default.createElement(
	          'a',
	          { href: '/issue/' + _this2.props.issue_data.issue_date + '/' + section_metadata.name + '/1' },
	          section_metadata.title
	        )
	      ) : null;
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      null,
	      issue_navigation.map(function (item) {
	        return item;
	      })
	    );
	  };
	
	  return IssueNavigation;
	}(_react2.default.Component);
	
	exports.default = IssueNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _issue_navigation = __webpack_require__(40);
	
	var _issue_navigation2 = _interopRequireDefault(_issue_navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    /**
	     * Array of magazine years in reverse chronological order
	     */
	    var magazine_years = Array.from(new Set(this.props.data.allThemenJson.edges.map(function (issue) {
	      return issue.node.jahr;
	    }))).sort(function (a, b) {
	      return a < b;
	    });
	
	    var issues_by_year = magazine_years.map(function (year) {
	      return {
	        year: year,
	        issues: _this2.props.data.allThemenJson.edges.filter(function (issue) {
	          return issue.node.jahr === year;
	        }).sort(function (a, b) {
	          return a.node.monat_num < b.node.monat_num;
	        }).map(function (issue) {
	          var issue_base_uri = '/issue/' + issue.node.issue_date;
	
	          issue.node.section_links = [issue.node.moving_image_count > 0 ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: issue_base_uri + '/moving_image/1' },
	              'moving image'
	            )
	          ) : null, issue.node.still_image_count > 0 ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: issue_base_uri + '/still_image/1' },
	              'still image'
	            )
	          ) : null, issue.node.textz_count > 0 ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: issue_base_uri + '/textz/1' },
	              'textz'
	            )
	          ) : null, issue.node.soundz_count > 0 ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: issue_base_uri + '/soundz/1' },
	              'soundz'
	            )
	          ) : null];
	          return issue;
	        })
	      };
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'issue' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sideBarLeft' },
	        _react2.default.createElement(
	          'div',
	          { className: 'impressum' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/about/' },
	                'about'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/editorial/' },
	                'editorial'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/contact/' },
	                'contact'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'archive' },
	          _react2.default.createElement(
	            'a',
	            { href: '/archive/' },
	            'archive'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'core-content' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'archives'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'special:issues'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The may 1998 issue "censoreship" showed censored works from the mus\xE9e de l\'art pornografique, lausanne, switzerland; the november 1998 issue was dedicated to the "phase 4" project of the k\xFCnstlerhaus stuttgart and rainer gelb; in june 2001 the e-zine featured i-love-u at the "communication front" in plovdiv, bulgaria; "mars", the october 2001 issue joined www.mars-patent.org. To be continued.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'i-love-u.ch V1 (1997 - 2005)'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The first Version of i-love-u.ch can be found ',
	          _react2.default.createElement(
	            'a',
	            { href: '/revolution/archive/archive.htm' },
	            'here'
	          )
	        ),
	        issues_by_year.map(function (year) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'year' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              year.year
	            ),
	            year.issues.map(function (issue) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'issue-toc' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'cover-thumbnail' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/issue/' + issue.node.issue_date },
	                    _react2.default.createElement('img', { src: '/media/covers/' + issue.node.thema_cover_uri })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-of-contents' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    issue.node.monat + ' ' + issue.node.jahr + ' | ' + issue.node.thema
	                  ),
	                  _react2.default.createElement(_issue_navigation2.default, { issue_data: issue.node })
	                )
	              );
	            })
	          );
	        })
	      ),
	      _react2.default.createElement('div', { className: 'nav-and-metadata' })
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-archive-js-c3240b9a41f234f9007e.js